<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="header fs18 pt20 pb10 pl15">请确认您的信息</h3>
      <div class="pl15 pr15 pb20 pt20">
        <p>姓名：{{ name }}</p>
        <p>预留手机号：{{ mobile|formatCardAndMobile(3,4,4) }} <span class="color_main" @click="onClick('mobile')">去修改</span>
        </p>
        <p>现住址：{{ address }} <span class="color_main" @click="onClick('address')">去修改</span></p>
      </div>
      <div class="footer flex pl15 pr15 pb15 pt15">
        <van-button round style="width: 45%" @click="onClick('cancel')">取消</van-button>
        <van-button type="info" round style="width: 45%" @click="onClick('confirm')">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {formatCardAndMobile} from "@/lib/filter";

export default {
  name: "yygh-confirm-information",
  filters: {formatCardAndMobile},
  data() {
    return {
      name: '',
      mobile: '',
      address: "",
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped>
.footer {
  justify-content: space-between;
}

p + p {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/yygh-confirm-information.vue